module.exports = __webpack_public_path__ + "img/request-offer-mobile@2x.4a319b2.png";